var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("div", { staticClass: "card search-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("HR 人員")]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        multiple: "",
                        "value-key": "Guid",
                        "collapse-tags": "",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.searchCondition.HRUserGuids,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchCondition, "HRUserGuids", $$v)
                        },
                        expression: "searchCondition.HRUserGuids",
                      },
                    },
                    _vm._l(_vm.supervisorOptions, function (supervisor) {
                      return _c("el-option", {
                        key: supervisor.Guid,
                        attrs: {
                          label: supervisor.Name,
                          value: supervisor.Guid,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("轉入時間")]),
                  _c("el-date-picker", {
                    staticClass: "w-100",
                    attrs: {
                      type: "datetimerange",
                      format: "yyyy-MM-dd HH:mm",
                      "start-placeholder": "開始時間",
                      "end-placeholder": "結束時間",
                    },
                    model: {
                      value: _vm.searchCondition.createTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "createTime", $$v)
                      },
                      expression: "searchCondition.createTime",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("分派時間")]),
                  _c("el-date-picker", {
                    staticClass: "w-100",
                    attrs: {
                      type: "datetimerange",
                      format: "yyyy-MM-dd HH:mm",
                      "start-placeholder": "開始時間",
                      "end-placeholder": "結束時間",
                    },
                    model: {
                      value: _vm.searchCondition.assignTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "assignTime", $$v)
                      },
                      expression: "searchCondition.assignTime",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-top": "30px", "margin-left": "10px" },
                  attrs: { type: "button" },
                  on: { click: _vm.search },
                },
                [_vm._v(" 查詢 ")]
              ),
              _vm.$Permission.ResumeAllocation.SpecialAllocation.IsValid
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-info",
                      staticStyle: {
                        "margin-top": "30px",
                        "margin-left": "10px",
                      },
                      attrs: { type: "button" },
                      on: { click: _vm.openModal },
                    },
                    [_vm._v(" 自動分派 ")]
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "yahome-table-wrap" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, stripe: "" },
            },
            [
              _c("el-table-column", { attrs: { prop: "Name", label: "姓名" } }),
              _c("el-table-column", {
                attrs: { prop: "Email", label: "Email" },
              }),
              _c("el-table-column", {
                attrs: { prop: "IdNo", label: "身分證" },
              }),
              _c("el-table-column", {
                attrs: { prop: "MobilePhone", label: "電話" },
              }),
              _c("el-table-column", {
                attrs: { prop: "Sex", label: "性別", width: "140" },
              }),
              _c("el-table-column", {
                attrs: { label: "HR 人員", width: "280" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-select",
                          {
                            staticClass: "w-100",
                            attrs: {
                              filterable: "",
                              disabled:
                                !_vm.$Permission.ResumeAllocation
                                  .SpecialAllocation.IsValid,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeAssign(props.row)
                              },
                            },
                            model: {
                              value: props.row.AssignHR,
                              callback: function ($$v) {
                                _vm.$set(props.row, "AssignHR", $$v)
                              },
                              expression: "props.row.AssignHR",
                            },
                          },
                          _vm._l(_vm.supervisorOptions, function (supervisor) {
                            return _c("el-option", {
                              key: supervisor.Guid,
                              attrs: {
                                label: supervisor.Name,
                                value: supervisor.Guid,
                              },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "分派時間" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$common.dateTimeFormatter(
                                props.row.AssignTime
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "CreateTime", label: "轉入時間" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$common.dateTimeFormatter(
                                props.row.CreateTime
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "聯繫紀錄" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.showContactInfo(props.row)
                              },
                            },
                          },
                          [_vm._v("聯繫紀錄")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              total: _vm.totalData,
              "page-size": 10,
              "current-page": _vm.tableInfo.page,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.tableInfo, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.tableInfo, "page", $event)
              },
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "assignModal",
            "data-focus": "false",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered" },
            [
              _c("ValidationObserver", {
                ref: "assign",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit, reset }) {
                      return [
                        _c(
                          "form",
                          {
                            on: {
                              reset: function ($event) {
                                $event.preventDefault()
                                return reset.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "modal-content" }, [
                              _c("div", { staticClass: "modal-header" }, [
                                _c("h5", { staticClass: "modal-title" }, [
                                  _vm._v("自動分派"),
                                ]),
                              ]),
                              _c("div", { staticClass: "modal-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("HR 人員 "),
                                    ]),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "HR 人員",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      filterable: "",
                                                      clearable: "",
                                                      multiple: "",
                                                      "collapse-tags": "",
                                                      placeholder: "請選擇",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.assign.HRUserGuids,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.assign,
                                                          "HRUserGuids",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "assign.HRUserGuids",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.supervisorOptions,
                                                    function (supervisor) {
                                                      return _c("el-option", {
                                                        key: supervisor.Guid,
                                                        attrs: {
                                                          label:
                                                            supervisor.Name,
                                                          value:
                                                            supervisor.Guid,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("轉入時間 "),
                                    ]),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "轉入時間",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("el-date-picker", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "datetimerange",
                                                    format: "yyyy-MM-dd HH:mm",
                                                    "start-placeholder":
                                                      "開始時間",
                                                    "end-placeholder":
                                                      "結束時間",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.assign.createTime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.assign,
                                                        "createTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "assign.createTime",
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "reset",
                                      "data-dismiss": "modal",
                                    },
                                  },
                                  [_vm._v(" 取消 ")]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return handleSubmit(_vm.autoAssign)
                                      },
                                    },
                                  },
                                  [_vm._v(" 確定 ")]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c("ContactInfoModal", { attrs: { personData: _vm.interviewee } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }